import { getController } from '@/services/service'

const url = 'handovertemplaterooms'

export const handoverTemplateRoomService = {
	...getController<
		Api.HandoverRoomTemplate,
		Api.HandoverTemplateRoomPostInput,
		Api.HandoverTemplateRoomUpdateInput
	>(url),
}

export default handoverTemplateRoomService
